export default function (context, value) {
    let type = 'min';
    let cb = ()=>{

    };
    let id = '';
    if (value) {
        if (value.type) type = value.type;
        if (value.cb) cb = value.cb;
        if (value.id) id = value.id;
    }
    context.commit('loading', true);
    if(id){

    }else{
        context.dispatch('rules/get', {
            cb: () => {
                cb(context.state);
                context.commit('loading', false);
            },
            type,
        });
    }
}